import { type SxProps, Table, TableContainer, type Theme } from '@mui/material';

const styles = {
  tableContainer: {
    boxShadow: 'none',
    flex: 1,
  },
  table: {
    tableLayout: 'auto',
  },
};

type ComponentTableProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const ComponentTable = ({ children, sx }: ComponentTableProps) => (
  <TableContainer sx={{ ...styles.tableContainer, ...sx }}>
    <Table sx={styles.table}>{children}</Table>
  </TableContainer>
);
